import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { SideBarBlock } from '@components/UI/SideBar'
import { ICampaignContextProps } from '@context/Campaign'
import { IApplicationState } from '@store'
import { selectSubmissionsFilters } from '@store/campaigns'
import { selectCampaignId } from '@store/router'
import InboxFiltersItem from './Item'

export interface IInternalProps extends ICampaignContextProps {
  currentView: string
  filters: ReadonlyArray<string>
}

const InboxFilters: React.FC = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const { filters } = useSelector((state: IApplicationState) => ({
    filters: selectSubmissionsFilters(state, campaignId),
  }), shallowEqual)
  return (
    <SideBarBlock
      header={<FormattedMessage id="inbox.sidebar.submissions" />}
      items={filters.map((filter: string) => (
        <InboxFiltersItem filter={filter} key={filter} />
      ))}
    />
  )
}

export { InboxFilters }
export default InboxFilters
